import { applyGameplayArtSpec } from './gameplayArtSpec.js';
import { applyGameplayArtPass3 } from './gameplayArtPass3.js';
import { applyGameplayArtPass4 } from './gameplayArtPass4.js';
import { applyGameplayArtPass5 } from './gameplayArtPass5.js';

export function applyGameplayArtPipeline(stage, level) {
  if (!stage) return () => {};
  const cleanups = [];

  // The exact Pass 1 geometry corrections are only appropriate for the locked
  // approved gameplay benchmark. Campaign levels retain the same forged visual
  // language without inheriting benchmark-specific bolt moves/hole placement.
  if (level.visualProfile === 'approved-gameplay-reference-04') {
    const cleanup = applyGameplayArtSpec(stage);
    if (typeof cleanup === 'function') cleanups.push(cleanup);
  }

  applyGameplayArtPass3(stage);
  applyGameplayArtPass4(stage);
  applyGameplayArtPass5(stage);
  stage.dataset.parityPass2Applied = 'true';
  stage.dataset.artPipeline = level.visualProfile || 'forged-campaign-v1';

  return () => cleanups.forEach((cleanup) => cleanup());
}
